import Link from 'next/link';
import Socials from './social';
import ReactMarkdown from 'react-markdown';

function Info({ socials, image, shortBio }) {
	return (
		<div className="card box">
			<div className="card-image center">
				<figure className=" image is-128x128">
					<img
						className="is-rounded"
						src={image.fields.file.url}
						alt={image.fields.description}
					/>
				</figure>
			</div>
			<div className="card-content">
				<ReactMarkdown>{shortBio}</ReactMarkdown>
				<br />
				<div className="content">
					<Link href="/">
						<a> @alaeddine </a>
					</Link>
					<br />
					<a href="#">#javascript</a> <a href="#">#fullstack</a>
					<a href="#">#backend</a> <a href="#">#frontend</a>
					<br />
					<Socials
						list={socials}
						showOnly={['linkedin', 'github', 'stackoverflow', 'twitter']}
						isMedium
					/>
					<div className="control center">
						<Link href="/contact">
							<a className="button is-black">Get in Touch</a>
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Info;
